import React, { FC } from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import { useFullscreen } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Layout/hooks/useFullscreen';

import { BaseControlProps } from '../../../types/controls';

import styles from './styles.module.css';

interface Props extends BaseControlProps {
    className?: string;
}

export const FullScreenToggle: FC<Props> = ({ className, onClick }) => {
    const { isFullscreen, toggleFullscreen } = useFullscreen();
    const intl = useIntl();

    return (
        <button
            aria-label={
                isFullscreen
                    ? intl.formatMessage({
                          id: 'features.legacy-player.3c164e4a018c337e6669142de60b2c8e',
                          defaultMessage: 'Exit full-screen mode',
                          description: 'Ариа атрибут для кнопки выхода из полноэкранного режима',
                      })
                    : intl.formatMessage({
                          id: 'features.legacy-player.e087a1742f0ff13d246fd925639a941b',
                          defaultMessage: 'Go to full-screen mode',
                          description: 'Ариа атрибут для кнопки входа в полноэкранный режим',
                      })
            }
            onClick={() => {
                toggleFullscreen();
                onClick?.();
            }}
            className={classnames(styles.root, className, {
                [styles.fullScreen]: isFullscreen,
            })}
        />
    );
};
